<template>
  <div class="talentedPeopleRight">
    <h3>诚聘英才</h3>
    <table
      v-for="(item, index) in tableData"
      :key="index"
      :class="[index % 2 === 1 ? 'even' : 'uneven']"
    >
      <tr  @click="showtoggele(index,item)">
        <span>{{ item.title }}</span>
        <span class="add" v-text="item.btnText"></span>
      </tr>
      <div class="text" v-show="item.isShow" v-if="tableData[id]">
        <p v-html="tableData[id].content">{{ tableData[id].conten }}</p>
      </div>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      btnText: "+",
      currentIndex: "",
      tableData: [],
      id: "",
    };
  },
  methods: {
    showtoggele(index,item) {
      this.id = index;
      item.isShow = !item.isShow;
      if (item.isShow) {
        item.btnText = "-";
      } else {
        item.btnText = "+";
      }
    },
  },
  created() {
    this.$api.joinus.job({}).then((res) => {
      let arr = res.data
      arr.forEach(item=>{
        item.isShow = false
        item.btnText = "+"
      })
      this.tableData = arr;
    });
  },
};
</script>

<style lang="less" scoped>
.talentedPeopleRight {
  width: 100%;
  height: 100%;
  .text {
    width: 823px;
    margin: auto;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    text-align: left;
    color: #666666;
    line-height: 28px;
    p{
      width: 100%;
      line-height: 40px;
      margin-left:10px;
    }
  }
  h3 {
    font-size: 24px;
    font-family: MicrosoftYaHei;
    text-align: left;
    color: #333333;
    margin-bottom: 20px;
  }
  tr {
    width: 876px;
    height: 48px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: 10px;
    .add {
      font-size: 20px;
      color: #ccc;
      cursor: pointer;
      padding-right: 20px;
    }
  }
  .uneven {
    background: #f5f5f5;
    .text{
      background: #fff;
    }
  }
  .even {
    background: #fff;
    border-bottom: 1px solid #dddddd;
    .text{
      background: #f5f5f5;
    }
  }
}
</style>